/**
 * The agent the shared ChatPanel talks to on the current surface.
 *
 * Every surface (main app, IVT, Event Hub) uses the user's agent from
 * AgentContext: their manual choice, else the job-role default among the agents
 * they may invoke. Only the main app lets dev/beta override it with `?agent=…`
 * for AG-UI testing; module surfaces ignore that parameter.
 */
export function chatAgentFor(
  currentAgent: string,
  { isModuleSurface, agUiEnabled, search }: { isModuleSurface: boolean; agUiEnabled: boolean; search: string },
): string {
  if (isModuleSurface || !agUiEnabled) return currentAgent;
  return new URLSearchParams(search).get('agent') ?? currentAgent;
}
